import DefaultDialogController from 'utils/notifications/default-dialog-controller';
import { initGrid } from 'utils/grid/grid';
import { getUsers } from 'user/user-service';
import DepsService from 'services/dependencies';

@Inject('gettextCatalog')
export default class CreateAccountUserSearchDialogController extends DefaultDialogController {
  constructor() {
    super();
    this.users = {};
    this.isLoading = false;
    this.selectedUserId = this.selectedUser ? this.selectedUser.id : null;
    this.initializeGrid();
    this.search();
  }

  initializeGrid() {
    this.defaultParams = {
      [DepsService.config.sortColumnKey]: 'contact.lastName',
      [DepsService.config.pageSizeKey]: 10,
    };
    this.filters = {};
    this.headers = [
      {
        text: '',
      },
      {
        text: this.gettextCatalog.getString('Name'),
        field: 'contact.lastName',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Email'),
        field: 'username',
        sortable: true,
        isAlignedLeft: true,
      },
    ];
    this.gridModel = initGrid(this.getUsers.bind(this), this.defaultParams);
  }

  clearFilters() {
    this.initializeGrid();
  }

  getUsers(parameters) {
    this.isLoading = true;
    return getUsers(parameters).then((response) => {
      this.isLoading = false;
      this.users = response;
    });
  }

  search() {
    this.gridModel.applyFilters();
  }

  select(user) {
    this.selectedUser = user;
    this.selectedUserId = user.id;
  }
}



// WEBPACK FOOTER //
// ./src/modules/retailer-groups/components/existing-user-field/dialog/create-account-user-search-dialog-controller.js